
<script>
import { Radio } from "element-ui";
export default {
  name: "aia-radio",
  extends: Radio
};
</script>